/**
 * Update pill number
 *
 * @param {HTMLElement} pill
 * @param {number} number
 */
function updatePill(pill, number) {
  if (number === 0)
    pill.removeAttribute('data-pill');
  else
    pill.dataset.pill = number;
}

export function updatePills() {
  const pills = Array.from(document.getElementsByClassName('js-pill'));
  if (pills.length === 0)
    return;

  pills.forEach(pill => {
    let pillNumber = 0;
    const dropdownPanId = pill.getAttribute('data-toggle');
    const dropdownPane = document.getElementById(dropdownPanId);

    const checkboxes = Array.from(dropdownPane.getElementsByTagName('input'));
    checkboxes.forEach(checkbox => {
      if (checkbox.checked)
        pillNumber++;

      updatePill(pill, pillNumber);

      checkbox.addEventListener('change', () => {
        if (checkbox.checked)
          pillNumber++;
        else
          pillNumber--;

        updatePill(pill, pillNumber);
      })
    })
  })
}

updatePills();
window.addEventListener('ajaxViewExposedFormAjax', () => {
  updatePills();
});
